import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'evidencia'
})
export class EvidenciaPipe implements PipeTransform {

  private readonly apiUrl = environment.api;

  private cache = new Map<
    string,
    Observable<SafeUrl | string>
  >();

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  private get token(): string {
    return localStorage.getItem('token') || '';
  }

  transform(
    filePath: string | null | undefined
  ): Observable<SafeUrl | string> {

    if (!filePath) {
      return of('');
    }

    const cached = this.cache.get(filePath);

    if (cached) {
      return cached;
    }

    const url =
      `${this.apiUrl}evidencia` +
      `?path=${encodeURIComponent(filePath)}`;

    console.log('URL evidencia:', url);

    const request$ = this.http
      .get(url, {
        headers: {
          'x-token': this.token
        },
        responseType: 'blob'
      })
      .pipe(

        map((blob: Blob) => {

          const objectUrl = URL.createObjectURL(blob);

          return this.sanitizer
            .bypassSecurityTrustUrl(objectUrl);

        }),

        catchError(error => {

          console.error(
            'Error al cargar evidencia:',
            error
          );

          return of('');

        }),

        shareReplay(1)
      );

    this.cache.set(filePath, request$);

    return request$;
  }
}